/* Dauber HQ FAQ — single-open accordion behavior by default; a list opts into
 * native multi-open by setting data-faq-multi="true". Single-open closes the
 * other <details> in the same .faq__list when one is opened.
 */

(function () {
  'use strict';

  function init() {
    var lists = document.querySelectorAll('.faq__list');
    lists.forEach(function (list) {
      // Default: home page = single open at a time
      var single = list.getAttribute('data-faq-multi') === 'true' ? false : true;
      if (!single) return;

      list.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          list.querySelectorAll('details').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
